const status = {
  GOOD: 'GOOD',
  BAD: 'BAD',
  ALERT: 'ALERT',
};

export default status;
